import React, { useState, useEffect } from 'react';
import './OrderDetailPage.css';

export default function CakePaymentsPage({ order }) {
  const [payments, setPayments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showDialog, setShowDialog] = useState(false);
  const [number, setNumber] = useState('');
  const [amount, setAmount] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  // Fetch payments for this order
  useEffect(() => {
    async function fetchPayments() {
      setLoading(true);
      setError('');
      try {
        const res = await fetch(`https://devbite.vercel.app/api/order_payments?orderid=${order.id}`);
        if (!res.ok) throw new Error('Failed to fetch payments');
        const data = await res.json();
        setPayments(data.payments || []);
      } catch (e) {
        setError(e.message);
      }
      setLoading(false);
    }
    if (order && order.id) fetchPayments();
  }, [order]);

  async function handleAddPayment(e) {
    e.preventDefault();
    setSubmitting(true);
    setError('');
    setSuccess('');
    try {
      const reference = Math.random().toString(36).substring(2, 12);
      const res = await fetch('https://devbite.vercel.app/initiateDeposite', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          reference,
          orderid: order.id,
          userid: order.createdBy || '',
          amount,
          phone_number: number,
        }),
      });
      const data = await res.json();
      if (res.ok && data.success) {
        setSuccess('Payment initiated! Reference: ' + data.reference);
        setShowDialog(false);
        setNumber('');
        setAmount('');
        // Re-fetch payments
        setTimeout(() => window.location.reload(), 1200);
      } else {
        setError(data.message || 'Failed to initiate payment');
      }
    } catch (e) {
      setError(e.message);
    }
    setSubmitting(false);
  }

  return (
    <div className="order-detail-section">
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 18 }}>
        <div className="order-detail-label">Cake Payments</div>
        <button className="order-detail-add-btn" onClick={() => setShowDialog(true)}>+ Add Payment</button>
      </div>
      {loading ? (
        <div className="order-detail-loading"><div className="spinner"></div></div>
      ) : error ? (
        <div className="order-detail-error">{error}</div>
      ) : payments.length === 0 ? (
        <div style={{ color: '#aaa', fontSize: 16, textAlign: 'center' }}>No payments yet.</div>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
          {payments.map((txn, i) => {
            let statusColor = '#aaa';
            if (txn.status === 'success') statusColor = '#27ae60';
            else if (txn.status === 'pending') statusColor = '#e67e22';
            else if (txn.status === 'failed') statusColor = '#e74c3c';
            return (
              <div key={txn.reference || i} className="order-detail-payment-card">
                <div className="order-detail-payment-status" style={{ background: statusColor }}>
                  {txn.status === 'success' ? '✔' : txn.status === 'pending' ? '⏳' : '✖'}
                </div>
                <div className="order-detail-payment-main">
                  <div className="order-detail-payment-amount">UGX {txn.amount}</div>
                  <div className="order-detail-payment-info">Phone: {txn.phone_number}</div>
                  <div className="order-detail-payment-info">Ref: {txn.reference}</div>
                  <div className="order-detail-payment-info">Status: <span style={{ color: statusColor, fontWeight: 600 }}>{txn.status?.toUpperCase()}</span></div>
                  <div className="order-detail-payment-info">Created: {txn.created_at?.replace('T', ' ').substring(0, 19)}</div>
                </div>
              </div>
            );
          })}
        </div>
      )}
      {showDialog && (
        <div className="order-detail-dialog-bg">
          <form className="order-detail-dialog" onSubmit={handleAddPayment}>
            <div className="order-detail-dialog-title">Add Payment</div>
            <input
              type="tel"
              className="order-detail-dialog-input"
              placeholder="Number"
              value={number}
              onChange={e => setNumber(e.target.value)}
              required
            />
            <input
              type="number"
              className="order-detail-dialog-input"
              placeholder="Amount to Pay"
              value={amount}
              onChange={e => setAmount(e.target.value)}
              required
            />
            <button className="order-detail-dialog-submit" disabled={submitting}>{submitting ? 'Submitting...' : 'Submit'}</button>
            <button type="button" className="order-detail-dialog-cancel" onClick={() => setShowDialog(false)}>Cancel</button>
            {error && <div className="order-detail-dialog-error">{error}</div>}
            {success && <div className="order-detail-dialog-success">{success}</div>}
          </form>
        </div>
      )}
    </div>
  );
}
